import React from 'react'
import { useTranslation } from 'react-i18next'
import {PaymentMethodLabelWithIcon, CardSchemeLabelWithIcon} from '@/components'
import { PaymentMethodType } from '@/constants'
import {PaymentMethodOrMaskedCardProps} from './props'

export const PaymentMethodOrMaskedCard: React.FC<PaymentMethodOrMaskedCardProps> = (props) => {
    const { t } = useTranslation('enums')
    const {
        paymentMethod,
        cardScheme,
        cardMask
    } = props

    if (!paymentMethod) return <span>-</span>

    if (paymentMethod === PaymentMethodType.card) {
        if (!cardScheme || !cardMask) return <span>-</span>

        return (
            <CardSchemeLabelWithIcon
                cardScheme={cardScheme}
                title={cardMask}
            />
        )
    }

    const title =
        paymentMethod === PaymentMethodType.clicktopay
            ? cardMask
            : t(`paymentMethodType.${paymentMethod}`, { defaultValue: paymentMethod })

    return (
        <PaymentMethodLabelWithIcon
            paymentMethod={paymentMethod}
            title={title}
        />
    )
}
